import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { ChevronRight, Wrench } from "lucide-react";
import Seo from "@/components/Seo";

export default function CategoriesPage() {
  const [cats, setCats] = useState([]);
  const [experts, setExperts] = useState([]);

  useEffect(() => {
    api.get("/categories").then((r) => setCats(r.data)).catch(() => {});
    api.get("/experts", { params: { limit: 200 } }).then((r) => setExperts(r.data)).catch(() => {});
  }, []);

  const countFor = (cid) => experts.filter((e) => (e.category_ids || [e.category_id]).includes(cid)).length;

  return (
    <><Seo title="Kategorier og fagområder | SpørgMig" description="Find eksperter efter kategori og få konkret hjælp til problemer inden for blandt andet IT, markedsføring og virksomhed." path="/kategorier"/><div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12" data-testid="categories-page">
      <div className="font-mono uppercase text-xs tracking-widest text-brand-muted">Kategorier</div>
      <h1 className="mt-1 text-2xl sm:text-3xl font-bold text-brand-ink">Find eksperter efter kategori</h1>
      <p className="mt-1 text-sm text-brand-body">Fra bremser til bagning – vælg det område dit problem passer bedst.</p>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {cats.map((c) => {
          const n = countFor(c.id);
          return (
            <Link
              key={c.id}
              to={`/kategorier/${c.slug}`}
              data-testid={`category-tile-${c.slug}`}
              className="card-outline p-4 flex items-center justify-between gap-3 hover-lift"
            >
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-md bg-brand-soft flex items-center justify-center text-brand-green">
                    <Wrench size={14}/>
                  </div>
                  <div className="min-w-0">
                    <div className="font-display font-semibold text-brand-ink text-[15px] truncate">{c.name}</div>
                    <div className="font-mono text-[10px] uppercase tracking-widest text-brand-muted">{c.slug}</div>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-xs text-brand-muted">{n} eksperter</span>
                <ChevronRight size={14} className="text-brand-muted"/>
              </div>
            </Link>
          );
        })}
        {cats.length === 0 && <div className="text-sm text-brand-muted">Ingen kategorier fundet.</div>}
      </div>

      <div className="mt-10 text-sm text-brand-body">
        Kan du ikke finde det rigtige? <Link to="/beskriv-problem" className="link-underline">Beskriv dit problem</Link> så matcher vi dig med de mest relevante eksperter.
      </div>
    </div></>
  );
}

